/**
 * Brand assets — the oddits logo files live in /public (project root).
 * publicDir is off in vite.config, so we IMPORT them (Vite fingerprints +
 * bundles into dist/public). Use these instead of hardcoded text marks.
 *
 *  logo      — full lockup (mark + wordmark), for LIGHT backgrounds (418×120)
 *  logoDark  — full lockup in Paper White, for DARK backgrounds
 *  icon      — the mark alone, transparent                           (163×163)
 *  iconTile  — the mark on a Highlighter Yellow tile                 (256×256)
 *
 * PNG, not SVG: these are cut from the Olito x Oddits artwork, which is
 * brush-drawn — the texture in the strokes is the point, and a vector trace
 * loses it. Source is 478px wide against a ~95px display width, so there is
 * headroom on a 2x screen. Swap to SVG only if the studio supplies real
 * vector outlines, not an autotrace.
 */
import logo from '../../../public/oddits-logo.png';
import logoDark from '../../../public/oddits-logo-dark.png';
import icon from '../../../public/oddits-icon.png';
import iconTile from '../../../public/oddits-icon-tile.png';

export const brand = { logo, logoDark, icon, iconTile } as const;
